import { createRealtimeStore } from "@stores/shared/createRealtimeStore";
import { REALTIME_EVENTS } from "@config/shared/realtime-events";
import useTenantContextStore from "@stores/shared/useTenantContextStore";

// System banner push (ADR-0051). BannerChanged only means "read the banner again": whatever
// the message carries is ignored, and the banner always comes from the tenant context. The
// hub sends it on every (re)connect, so a tab that was offline catches up, and after every
// admin save.
export const createBannerChannelStore = (connection) =>
  createRealtimeStore({
    name: "bannerChannel",
    connection,
    events: {
      [REALTIME_EVENTS.BANNER_CHANGED]: () => () => useTenantContextStore.getState().refresh(),
    },
  });

const useBannerChannelStore = createBannerChannelStore();

export default useBannerChannelStore;
